import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AWS from 'aws-sdk'
import { STSCredential } from '@/interfaces/sts-credential'
import { File as AppFile, FileToSave } from '@/modules/File/interfaces/file'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import { getTextractTempCredentials, getFileViewUrl } from '@/modules/File/gql/file.gql'

@Component
export default class S3Handler extends Vue {
  stsCredentialAI: STSCredential | null = null
  filesToUploadAI: File[] = []
  fileUploadedAI: AppFile | null = null

  filesInfoAI: FileToSave[] = []
  awsS3PrefixAI = process.env.VUE_APP_S3_URL // s3地址

  notesAI = ''

  fileTypeAI = ''

  progressValue = 0 // 进度值

  blobUrl = ''
  previewFileTypeAI = ''
  isToDelete = false

  storeKeyAI = ''

  // 获取权限
  async getSTSCredentialsAI () {
    try {
      const result = await this.$apollo.query({
        query: getTextractTempCredentials
      })
      this.stsCredentialAI = result.data.getTextractTempCredentials
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async uploadFileToS3AI (index: number) {
    if (!this.stsCredentialAI || this.filesToUploadAI.length === 0) return
    // 临时授权参数
    const { region, accessKeyId, secretAccessKey, sessionToken, bucket } = this.stsCredentialAI
    // 需要上传的文件file类型
    const { filesToUploadAI } = this
    const client = new AWS.S3({
      region: region,
      accessKeyId: accessKeyId,
      secretAccessKey: secretAccessKey,
      sessionToken: sessionToken
    })

    const fileToUpload = filesToUploadAI[index]

    const timeStamp = (new Date()).valueOf()

    const extension = this.$R.last(fileToUpload.name.split('.'))

    const rdnSuffix = Math.floor(Math.random() * 1000)

    const storeKey = `${timeStamp}${rdnSuffix}.${extension}`

    const params = {
      ACL: 'private',
      Bucket: bucket,
      Key: storeKey,
      Body: fileToUpload
    }
    const request = client.putObject(params)

    request.on('httpUploadProgress', (evt) => {
      const uploadedBytes = evt.loaded
      const totalBytes = evt.total
      const percentage = Math.round((uploadedBytes / totalBytes) * 100)
      // 更新进度条
      this.progressValue = percentage
      if (this.isToDelete) {
        request.abort()
        this.clearFileAI()
      }
    })

    request.send((err, data) => {
      if (err) {
        showErrors({
          msg: 'File uploading failed! Error:' + err,
          type: SnackType.Error
        })
      } else {
        const url = this.awsS3PrefixAI + '/' + storeKey
        this.filesInfoAI.push({
          url: url,
          name: fileToUpload.name,
          size: fileToUpload.size,
          type: this.fileTypeAI,
          notes: this.notesAI
        })
        this.storeKeyAI = storeKey
        this.previewFileAI(url, fileToUpload.name)
      }
    })
  }

  async previewFileAI (url: string, fileName: string) {
    if (!this.checkCredentialValidAI()) {
      await this.getSTSCredentialsAI()
    }
    await this.previewFileFromS3AI(url, fileName)
  }

  async previewFileFromS3AI (fileUrl: string, fileName: string) {
    const blob = await this.getS3FileBlobAI(fileUrl)
    if (blob) {
      this.showFileAI(blob, fileName)
    }
  }

  async getS3FileBlobAI (fileUrl: string): Promise<Blob | null> {
    if (!this.stsCredentialAI || !this.awsS3PrefixAI) return null
    const { region, accessKeyId, secretAccessKey, sessionToken, bucket } = this.stsCredentialAI

    const storeKey = this.$R.last(fileUrl.split(this.awsS3PrefixAI + '/')) || ''
    if (!storeKey) {
      showNotification({
        msg: 'Downloading failed!',
        type: SnackType.Error
      })
      return null
    }
    const client = new AWS.S3({
      region: region,
      accessKeyId: accessKeyId,
      secretAccessKey: secretAccessKey,
      sessionToken: sessionToken
    })
    try {
      const file: any = await client
        .getObject({ Bucket: bucket, Key: storeKey })
        .promise()
      const blob = new Blob([new Uint8Array(file.Body)])
      return blob
    } catch (error) {
      showNotification({
        msg: 'Downloading failed! Error:' + error,
        type: SnackType.Error
      })
      return null
    }
  }

  showFileAI (blob: Blob, fileName: string) {
    this.blobUrl = window.URL.createObjectURL(blob)
    this.previewFileTypeAI = this.$R.last(fileName.split('.'))
  }

  checkCredentialValidAI () {
    if (!this.stsCredentialAI) return false
    return this.$moment().isBefore(this.$moment.utc(this.stsCredentialAI.expiration).local())
  }

  clearFileAI () {
    this.filesInfoAI = []
    this.filesToUploadAI = []
    this.isToDelete = false
    this.progressValue = 0
    this.blobUrl = ''
  }
}
